// extracted by mini-css-extract-plugin
module.exports = {"saved-searches":"SavedMapList_saved-searches__2US1u","saved-searches__item":"SavedMapList_saved-searches__item__3oGhZ"};